import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

const Home = lazy(() => import("@/pages/Home"));
const AboutOSC = lazy(() => import("@/pages/AboutOSC"));
const EntrepreneurFiles = lazy(() => import("@/pages/EntrepreneurFiles"));
const CompanionWorkbook = lazy(() => import("@/pages/CompanionWorkbook"));
const StartABusiness = lazy(() => import("@/pages/StartABusiness"));
const RunABusiness = lazy(() => import("@/pages/RunABusiness"));
const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const LeadMagnet = lazy(() => import("@/pages/LeadMagnet"));
const BusinessReadinessAssessment = lazy(() => import("@/pages/BusinessReadinessAssessment"));
const BusinessControlAssessment = lazy(() => import("@/pages/BusinessControlAssessment"));
const AboutMarcus = lazy(() => import("@/pages/AboutMarcus"));
const Contact = lazy(() => import("@/pages/Contact"));
const StrategyCall = lazy(() => import("@/pages/StrategyCall"));
const Coaching = lazy(() => import("@/pages/Coaching"));
const CoachingAdvisory = lazy(() => import("@/pages/CoachingAdvisory"));
const StrengthenABusiness = lazy(() => import("@/pages/StrengthenABusiness"));
const ControlInstallation = lazy(() => import("@/pages/ControlInstallation"));
const StandingAdvisory = lazy(() => import("@/pages/StandingAdvisory"));
const Purchase = lazy(() => import("@/pages/Purchase"));
const Brand = lazy(() => import("@/pages/Brand"));
const CheckoutSuccess = lazy(() => import("@/pages/CheckoutSuccess"));
const CheckoutCancel = lazy(() => import("@/pages/CheckoutCancel"));
const FlipbookAccess = lazy(() => import("@/pages/FlipbookAccess"));
const EbookAccess = lazy(() => import("@/pages/EbookAccess"));
const Legal = lazy(() => import("@/pages/Legal"));
const Admin = lazy(() => import("@/pages/Admin"));
const DomainLanding = lazy(() => import("@/pages/DomainLanding"));

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-osc-black">
      <div className="stamp text-osc-gold animate-pulse">[ Accessing Codex... ]</div>
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* Standalone artwork routes (no nav/footer/ribbon) */}
        <Route path="/landing" element={<DomainLanding />} />

        {/* Main site routes (wrapped in Layout) */}
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about-osc" element={<AboutOSC />} />
                <Route path="/the-entrepreneur-files" element={<EntrepreneurFiles />} />
                <Route path="/companion-workbook" element={<CompanionWorkbook />} />
                <Route path="/start-a-business" element={<StartABusiness />} />
                <Route path="/run-a-business" element={<RunABusiness />} />
                <Route path="/launch-run-grow" element={<Navigate to="/" replace />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/field-reports" element={<LeadMagnet />} />
                <Route path="/free-startup-audit" element={<Navigate to="/field-reports" replace />} />
                <Route path="/business-readiness-assessment" element={<BusinessReadinessAssessment />} />
                <Route path="/business-control-diagnostic" element={<BusinessControlAssessment />} />
                <Route path="/business-control-assessment" element={<Navigate to="/business-control-diagnostic" replace />} />
                <Route path="/about-marcus" element={<AboutMarcus />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/book-strategy-call" element={<StrategyCall />} />
                <Route path="/apply-coaching" element={<Coaching />} />
                <Route path="/coaching-advisory" element={<CoachingAdvisory />} />
                <Route path="/coaching" element={<Navigate to="/coaching-advisory" replace />} />
                <Route path="/control-installation" element={<ControlInstallation />} />
                <Route path="/standing-advisory" element={<StandingAdvisory />} />
                <Route path="/purchase/:token" element={<Purchase />} />
                <Route path="/brand" element={<Brand />} />
                <Route path="/strengthen-a-business" element={<StrengthenABusiness />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/checkout/cancel" element={<CheckoutCancel />} />
                <Route path="/access/flipbook" element={<FlipbookAccess />} />
                <Route path="/access/ebook" element={<EbookAccess />} />
                <Route path="/legal/:slug" element={<Legal />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
              <Toaster richColors theme="dark" />
            </Layout>
          }
        />
      </Routes>
    </Suspense>
  );
}
